"use client";
import PropTypes from "prop-types";
import ButtonComponent from "../../../atoms/button";
import Typography from "../../../atoms/typography";
import { useEffect, useState } from "react";
import { getCallChatTime } from "../../../../api/common";
import { openSiteChat } from "../../../../customHooks/useFnpChat/openSiteChat";

/**
 * ChatWithUs component renders Chat With Us clickable button.
 * @param {Object} props - The props object
 * @param {Object} props.details - Object containing text details.
 * @param {string} props.chatWitUsSwitch - Text containing chat with us switch
 * @returns {JSX.Element} FooterInfo component JSX
 */
export const ChatWithUs = ({ details }) => {
  const [chatWitUsSwitch, setChatWitUsSwitch] = useState("");

  /**
   *  fetch chat with us switch value from API.
   */
  useEffect(() => {
    /**
     * This function fetches the chat with us switch value from the API and sets it in the state.
     */
    async function fetchChatWithUsSwitch() {
      const chatWithUsResponse = await getCallChatTime();
      setChatWitUsSwitch(chatWithUsResponse?.callTime?.switch);
    }
    fetchChatWithUsSwitch();
  }, []);

  /**
   * This function handles chat with us on click event
   */
  const onChatWithUsClick = () => {
    openSiteChat();
  };

  return (
    <>
      {chatWitUsSwitch === "N" ? (
        <ButtonComponent
          size="textBtn"
          label={details.subheading2}
          classes="text-grey-500 justify-start"
          buttonVariant="underlineText"
          buttonTextSize="small"
          onClick={onChatWithUsClick}
        />
      ) : (
        <Typography variant="subheading4" Tag="p" classes="text-12 font-400 text-grey-500">
          {details.subheading1}
        </Typography>
      )}
    </>
  );
};

ChatWithUs.propTypes = {
  details: PropTypes.object.isRequired,
};

export default ChatWithUs;
